<template>
  <div class="hello">
    <div id="back-particles"/>   
    <Topbar />
    <div class="clearfix"></div>

    <div id="header">
      <h2>"Innovation and Collaboration is Our Culture"</h2>
      <h3>EVERYTHING IS POSSIBLE AT ECHWOOD</h3>
      <div>
        <a class="slack-button" target="_blank" href="https://echwoodhub.slack.com">
          Join Us on <img class="sla-mg" style="width:1%,height:1%" src="../assets/sl.png">Slack
        </a>
      </div>
    </div>
    <section>
      <h2></h2>
    </section>

    <div>
      <div class="row contain">
        <div
          class="small-12 medium-6 large-4 columns"
          :class="{ end: content.indexOf(i) === content.length - 1 }"
          v-for="i in content" :key="i.title">
          <div class="hov card">
            <div class="card-divider" >
              <strong>{{i.title}}</strong>
            </div>
            <img :src="i.imgsrc">
            <div class="card-section">
              <h5>{{i.subtitle}}</h5>
              <p>{{i.description}}</p>
              <div v-if="i.buttn" class="button">{{i.buttn}}</div>
            </div>
          </div>
        </div>
      </div>


      <section class="tawk">
        <div class="overlay"></div>
        <div  class="row info">
          <div class="small-12 medium-5 large-4 imeg column">
            <h2>Seminars</h2>
            <h2> &amp;</h2>
            <h2> Talks</h2>
          </div>
          <!-- <img class="" src="../assets/event.png"> -->
          <div class="small-12 medium-7 large-8 column text">
            If you host seminars, talks, conferences and so on, or are a speaker,
            please let us know about your upcoming talks or seminars by mailing
            <a href="mailto:admin@echwood.com">admin@echwood.com</a> and we will announce your event and send assistants,
            if need be.
            We'll also be glad to send materials accross, some T-shirts for you and some wrist bands, stickers and
            swag for the attendees of your event. We can also partner with you.
          </div>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Topbar from '../components/Topbar'
import galaxyjson from "../assets/galaxy.json"

export default {
  name: 'home',
  props: {
    msg: String
  },
  data () {
    return {
      content: [
        {
          title: 'Events',
          subtitle: 'We love sharing',
          description: 'We host series of events across the year in different locations. We also do dispatch developers for talks, when invited. Our purpose of setting up events is for the growth of innovators, techprenuers and some other persons who might find technology driven solutions as fun.',
          imgsrc: ''
        },
        {
          title: 'Internship',
          subtitle: 'Growing Together',
          description: 'Our dream is to support, empower and work with developers as interns and watch them grow into independent techprenuers. Gaining enough experience to handle projects of any sought',
          imgsrc: '',
          buttn: 'Join Echwood Interns' 
        },
        {
          title: 'Career',
          subtitle: 'Come Join US',
          description: 'We are looking forward to creating technology driven solutions that will advance businesses and enhance soceital values. We are looking forward to working with enthusaists like us, who does\'t just have skills . We are keen to have your work with us. Join us by mailing admin@echwood.com.  expecting you...',
          imgsrc: ''
        }
      ]
  }
  },

  mounted () {
    particlesJS('back-particles', galaxyjson)
  },

  components: { Topbar }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div {
  color: white;
  user-select: none
  
}

p {
  line-height: 1.6;
  font-size: 15px;
  margin: .3em;
  padding: .7em 1.2em;
  font-weight: 200;
  letter-spacing: 1px;
}

.sla-mg {
  /* height: 2em; */
  width: 2em;
}

.slack-button {
  padding: .7em 2em;
  background-color: #FEFEFE;
  margin-top: 1em;
  border-radius: 3.5px;
  font-size: 18px;
  display: block;
  border: 1px solid #FEFEFE;
  box-shadow: 0 0 2em 1px #777;
  transition: all 0.25s ease-in-out 0s;
  /* text-transform: uppercase */
}

.slack-button:hover {
  background-color: transparent;
  color: #FEFEFE;
}

.imeg {
  filter: contrast(1);
  filter: grayscale(-1);
}
#header {
  display: flex;
  flex-direction: column;
 /* height: 33vh; */
 align-items: center;
 justify-content: center;
 margin: auto;
 text-align: center  
}

#header h2 {
  margin: 2em auto .5em;
  font-weight: 200;
  font-size: 45px;
}

#header h3 {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 4px;
  text-shadow: 0 0 .1em #FEFEFE;
}

.tawk {
  /* margin-top: 10%; */
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  background-color: #FEFEFE;
  background-image: url('../assets/seminar.jpg');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-position: 50% 50%;
  height: 45vh;
  margin: 2em auto;
  /* border-left: 4px solid #2199e8;
  border-right: 4px solid #2199e8; */
  padding: 1em;
  box-shadow: 0 0 3em #222
}

.tawk div {
  color: #ffffff;
}

.tawk h2 {
  font-weight: 600;
  letter-spacing: 1px;
  color: #EAEAEA;
  margin: 0;
  padding: 0;
}

.tawk .overlay {
  background-color: rgba(0, 0, 0, 0.7);
  /* width: 100%;
  height: 100%; */
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.tawk .text {
  color: #FFF;
  font-size: 20px;
  font-weight: 300;
  line-height: 1.8;
  text-align: justify;
}

.tawk .info {
  z-index: 800;
}

h5 {
  font-weight: 200;
  font-size: 25px;

}

.card {
  padding-top: 1em;
  margin-bottom: .5em;
  border-radius: 3.5px;
  min-height: 22em;
  position: relative;
  background: rgba(0, 0, 0,0.5);
  /* background: #FEFEFE; */
  transition: all 0.3s linear 0s;
}

.card:hover {
  /* transform: scale(1.02); */
}

.card .button {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 0 0 3.5px 3.5px;
  /* background-color: rgba(0, 0, 0, 0.5); */
  padding: 1.2em;
  width: 100%;
  outline: 0;
  margin: 0;
  font-weight: 600;
  text-shadow: 0 0 .6em #666;
  letter-spacing: 1.4px;
  cursor: pointer;
  text-transform: uppercase;
}

.card-divider {
  font-weight: 500;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1.3px;
}

/* .hov:hover {
  color: black;  
  border-radius: .5em;
  background: rgba(0, 0, 0, 0.8);
} */

div.contain {
  /* padding: 0.5%; */
  margin: 2em auto auto;
  background: transparent
}

div#back-particles {
   background-image: url("../assets/ech.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.slack {
  padding: .5em;
  /* margin-top: 2em; */
}

div.slack:active {
  /* padding: .5em;
  color:black;
  background: rgba(253, 253, 253, 0.5);
  user-select: none; */

}

section {
  background: transparent
}

@media screen and (min-width: 320px) and (max-width: 895px) {
  #header h2 {
    font-size: 30px;
    width: 90%;
    margin: 2em auto 1em;
  }

  #header h3 {
    font-size: 15px;
  }
  .tawk {
    height: 53vh;
  }
  .imeg {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }
  .tawk .text {
    width: 100%;
    font-size: 15px;
  }
}
</style>
